import { Stack, Tooltip, Typography } from '@mui/material';

import { MinimalTarget } from '@/generated/model';
import { inactiveTargetStates } from '@/tmp/Target';

import './TargetNameAndDescription.css';

// eslint-disable-next-line react-refresh/only-export-components
export function targetNameAndDescriptionStyle(
  selected: boolean | undefined,
  hasStatus: boolean | undefined,
  inactive = false
): StyleClassName {
  switch (selected) {
    case true:
      switch (hasStatus) {
        case false:
          return 'target-name-and-description-selected-nostatus';
        case true:
        case undefined:
          return 'target-name-and-description-selected';
      }
      break;
    case false:
      if (inactive) {
        return 'target-name-and-description-inactive';
      }
      return 'target-name-and-description-nonselected';
    case undefined:
      return 'target-name-and-description-header';
  }
}

// eslint-disable-next-line react-refresh/only-export-components
export function isTargetInactiveByState(target: MinimalTarget) {
  return inactiveTargetStates.includes(target.state);
}

type StyleClassName =
  | 'target-name-and-description-selected-nostatus'
  | 'target-name-and-description-selected'
  | 'target-name-and-description-inactive'
  | 'target-name-and-description-nonselected'
  | 'target-name-and-description-header';

export function TargetNameAndDescription({
  targetName,
  targetDescription,
  styleClassName,
  truncate,
}: {
  targetName: string | undefined;
  targetDescription: string | undefined;
  styleClassName: StyleClassName;
  truncate?: boolean;
}) {
  const isHeader = styleClassName === 'target-name-and-description-header';
  const targetNameElement = (
    <Typography variant={isHeader ? 'h6' : 'body2'} noWrap={truncate} data-qa-element-id="target_name">
      {targetName}
    </Typography>
  );
  const targetDescriptionElement = (
    <Typography
      variant={isHeader ? 'subtitle2' : 'helperText'}
      noWrap={truncate}
      sx={{
        color: 'inherit',
        opacity: 0.65,
        lineHeight: 1,
        textOverflow: 'ellipsis',
        whiteSpace: truncate ? 'nowrap' : 'break-spaces',
        display: truncate ? 'block' : '-webkit-box',
        WebkitLineClamp: truncate ? 'unset' : 2,
        lineClamp: truncate ? 'unset' : 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      }}
      data-qa-element-id="target_description"
    >
      {targetDescription}
    </Typography>
  );

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        textAlign: 'start',
        overflowWrap: 'break-word',
        ...(truncate && { minWidth: 0 }),
        ...(isHeader && { justifyContent: 'flex-start' }),
      }}
      className={styleClassName}
    >
      {truncate ? <Tooltip title={targetName}>{targetNameElement}</Tooltip> : targetNameElement}
      {truncate ? <Tooltip title={targetDescription}>{targetDescriptionElement}</Tooltip> : targetDescriptionElement}
    </Stack>
  );
}
